module.exports = __webpack_public_path__ + "static/cd-ht-intro-image-2-796a6647fe948c3b3f59e0c06a0fa809.svg";